import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

const KitchenEquipmentItem = ({ itemData }: any) => {
  return (
    <Grid
      container
      spacing={2}
      className="app-kitchenEquipmentItem__card-wrapper"
    >
      <Grid item xs={12}>
        <Card className="app-kitchenEquipmentItem__card-container">
          <div>
            <h2 className="app-kitchenEquipmentItem__headText">
              {itemData.title}
            </h2>
          </div>
          <Grid
            container
            spacing={2}
            className="app-kitchenEquipmentItem__card-item"
          >
            {itemData.equipmentItem &&
              itemData.equipmentItem.length > 0 &&
              itemData.equipmentItem.map((valItem: any, valItemIndex: any) => {
                return (
                  <Grid
                    key={`app-kitchenEquipmentItem__card-figureGrid-${valItemIndex}`}
                    item
                    xs={6}
                    md={4}
                    lg={3}
                    className="app-kitchenEquipmentItem__card-figureGrid"
                  >
                    <figure className="app-kitchenEquipmentItem__card-figure">
                      <img
                        src={valItem.imgSrc}
                        alt={valItem.imgAlt}
                        className="app-kitchenEquipmentItem__card-img"
                      />
                      <figcaption className="app-kitchenEquipmentItem__card-figcaption">
                        {valItem.imgCaption}
                      </figcaption>
                    </figure>
                  </Grid>
                );
              })}
          </Grid>
        </Card>
      </Grid>
    </Grid>
  );
};

export default KitchenEquipmentItem;
